function recaptchaCallbackFunction() {
  document.getElementById("submit").disabled = "";
}

//reCAPTCHAがrecaptchaCallbackFunction関数を実行できるように、windowオブジェクトに関連付ける
window.recaptchaCallbackFunction = recaptchaCallbackFunction;
